var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{attrs:{"role":"button"},on:{"click":function($event){return _vm.$emit('edit')}}},[_c('td',[_vm._v(_vm._s(_vm.item.date))]),_c('td',[_vm._v(_vm._s(_vm.range))]),_c('td',[_vm._v(_vm._s(_vm.selection))]),_c('td',{staticClass:"text-right"},[_c('DeleteOne',{attrs:{"item":_vm.item}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }